// RxJS
import { delay, distinctUntilChanged } from 'rxjs/operators';
// CRUD
import { QueryResultsModel, BaseDataSource } from '../../_base/crud';
// State
import { Store, select } from '@ngrx/store';
import { AppState } from '../../reducers';
// Selectors
import { selectQuartelsInitWaitingMessage, selectQuartelsInStore, selectQuartelsPageLoading } from '../_selectors/quartel.selectors';

export class QuartelsDataSource extends BaseDataSource {
	constructor(private store: Store<AppState>) {
		super();
		this.loading$ = this.store.pipe(
			select(selectQuartelsPageLoading)
		);

		this.isPreloadTextViewed$ = this.store.pipe(
			select(selectQuartelsInitWaitingMessage)
		);

		this.store.pipe(
			select(selectQuartelsInStore)
		).subscribe((response: QueryResultsModel) => {
			this.paginatorTotalSubject.next(response.totalCount);
			this.entitySubject.next(response.items);
		});
	}
}
